'use strict'

require '../../src/frontend/desktop_sls'



// WEBPACK FOOTER //
// ./core/frontend/sls-vVERSION.coffee